import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Notification from '~/components/Notification';

const propTypes = {
  currentColorId: PropTypes.string,
  deleteProduct: PropTypes.func,
  dismiss: PropTypes.func,
  notification: PropTypes.shape({
    mode: PropTypes.string
  }),
  removeAllNamesAndNumbers: PropTypes.func,
  selections: PropTypes.array
};

/** @extends {Component<PropTypes.InferProps<typeof propTypes>>} */
export class MultiStyleNamesAndNumbersNotification extends Component {
  static displayName = 'MultiStyleNamesAndNumbersNotification';
  static propTypes = propTypes;

  handleRemoveNamesAndNumbers = () => {
    this.props.removeAllNamesAndNumbers();
    this.props.dismiss();
  };

  handleRemoveComplements = () => {
    const {currentColorId, deleteProduct, selections} = this.props;
    selections
      .filter(colorId => colorId !== currentColorId)
      .forEach(colorId => deleteProduct({colorId}));
    this.props.dismiss();
  };

  render() {
    const isAddingStyles = this.props.notification.mode === 'addingStyles';
    return (
      <Notification {...this.props} title="We can’t do this online…yet.">
        <p className="ndx-cta1">
          Our Design Lab can’t place a multiple color/item order with names and
          numbers.
        </p>
        <Button
          size="large"
          variant="secondary"
          className="notification-cta notification-Link"
          href="#/help"
          onClick={this.props.dismiss}>
          Contact Us
        </Button>
        <p className="ndx-cta1">
          <br />
          or{' '}
          {isAddingStyles ? (
            <Link href="#/addItems" onClick={this.handleRemoveNamesAndNumbers}>
              remove names and numbers
            </Link>
          ) : (
            <Link
              href="#/namesAndNumbers"
              onClick={this.handleRemoveComplements}>
              remove extra colors and items
            </Link>
          )}
          .
        </p>
      </Notification>
    );
  }
}

import {createStructuredSelector} from 'reselect';
import {
  getColorSelections,
  getCurrentColorId
} from '~/selectors/ProductSelectors';

function select() {
  return createStructuredSelector({
    currentColorId: getCurrentColorId,
    selections: getColorSelections
  });
}

import {bindActionCreators} from 'redux';
import {removeAll} from '~/actions/NamesAndNumbersActions';
import {deleteProduct} from '~/actions/ProductActions';

function actions(dispatch) {
  return bindActionCreators(
    {
      deleteProduct,
      removeAllNamesAndNumbers: removeAll
    },
    dispatch
  );
}

import {connect} from 'react-redux';
import {Button, Link} from '@customink/pigment-react';

export default connect(select, actions)(MultiStyleNamesAndNumbersNotification);
